/**
 * Which language a page is written in, and which page (if any) is its
 * translation — the reciprocal pair `hreflang` exists to state.
 *
 * Its own module, with no imports, for the reason `og.ts` gives for the same
 * shape: the router runs in the shell bundle and must stay small, and
 * `scripts/prerender.mjs` needs the identical answer at build time. Content
 * modules (`backends.ts`, `docs.ts`…) stay out of both.
 *
 * Only a page that is genuinely the SAME document in two languages gets a
 * pair. `/legal/cgv`, `/legal/cookies`, `/legal/mentions-legales` and
 * `/legal/sous-traitance` are French with no English counterpart at all —
 * `TRANSLATION_OF` does not name them, because an hreflang pair asserts two
 * URLs are interchangeable for a reader, and telling a search engine that
 * about two pages that say different things is wrong in the direction that
 * matters: it can make the wrong one rank for the right query.
 */

const FRENCH_PATHS = new Set([
  '/legal/mentions-legales',
  '/legal/confidentialite',
  '/legal/cgu',
  '/legal/cgv',
  '/legal/cookies',
  '/legal/licence',
  '/legal/sous-traitance',
])

/** Every other path on the site is English. */
export function langFor(path: string): 'en' | 'fr' {
  return FRENCH_PATHS.has(path) ? 'fr' : 'en'
}

/**
 * Reciprocal translation pairs, both directions, so either side of a pair
 * finds the other with one lookup. The three the French legal set actually
 * has an English equivalent for.
 */
export const TRANSLATION_OF: Record<string, string> = {
  '/legal/confidentialite': '/legal/privacy',
  '/legal/privacy': '/legal/confidentialite',
  '/legal/cgu': '/legal/terms',
  '/legal/terms': '/legal/cgu',
  '/legal/licence': '/legal/license',
  '/legal/license': '/legal/licence',
}
